<template>
    <Head v-if="title" :title="title" />

    <div class="font-sans text-gray-900 antialiased">
        <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
            <div>
                <a href="/">
                    <LogoImg class="h-16" />
                </a>
            </div>

            <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                <slot></slot>
            </div>

        </div>
    </div>

</template>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import LogoImg from "../Components/LogoImg";
export default {
    props: {
        title: String,
    },
    name: "CenterBox",
    components: {LogoImg, Head },
    mounted(){
        this.reportConversion();
    },
    methods: {
        reportConversion(){
            if(!localStorage.getItem('reportConversion')) return;
            gtag('event', 'registered', { event_label: 'registered', value: true });
            localStorage.removeItem('reportConversion');
        },
    }
}
</script>

<style scoped>

</style>
